/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2023-02-21 15:44:06
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2023-03-14 16:20:02
 * @FilePath: \pigbox\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "../views/Login/Login"
import Home from "../views/Home/Home"
import Shop from "../views/Shop/Shop"
import Goods from "../views/Goods/Goods"
import Withdrawal from "../views/Withdrawal/Withdrawal"
import Popularize from "../views/Popularize/Popularize"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    children: [
      {
        path: '/shop',
        name: 'Shop',
        component: Shop
      },
      {
        path: '/goods',
        name: 'Goods',
        component: Goods
      },
      {
        path: '/withdrawal',
        name: 'Withdrawal',
        component: Withdrawal
      },
      {
        path: '/popularize',
        name: 'Popularize',
        component: Popularize
      },


    ]

  },


]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
